import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { getUxPanelImages, getArchivedUxPanelImages, archiveUxPanelImage, restoreUxPanelImage, } from '../../api/ux-panel-images';
import { getUxPanels } from '../../api/ux-panels';
import EntityArtManager from '../EntityArtManager/EntityArtManager';
const UxPanelsArt = ({ levelId, refreshTrigger, nodes }) => {
    // panelId → the cell whose challenge outcome pops it (a show_ux_panel action).
    const coordByPanelId = useMemo(() => {
        var _a, _b;
        const m = new Map();
        for (const [coord, data] of Object.entries(nodes !== null && nodes !== void 0 ? nodes : {})) {
            for (const se of (_a = data.simpleEvents) !== null && _a !== void 0 ? _a : []) {
                for (const outcome of [se.success, se.failure]) {
                    for (const act of (_b = outcome === null || outcome === void 0 ? void 0 : outcome.actions) !== null && _b !== void 0 ? _b : []) {
                        const a = act;
                        if (a.action === 'show_ux_panel' && a.uxPanelId)
                            m.set(a.uxPanelId, coord);
                    }
                }
            }
        }
        return m;
    }, [nodes]);
    const linkage = useMemo(() => ({
        strategy: 'parallel',
        load: getUxPanels,
        describeLinks: (img, uxPanels) => {
            const linked = uxPanels.filter(panel => panel.backgroundImage === img.imageUrl || panel.centerImage === img.imageUrl);
            const coords = [...new Set(linked.map(p => coordByPanelId.get(p.id)).filter((c) => !!c))];
            return {
                count: linked.length,
                badgeText: linked.length > 0 ? linked.length.toString() : '',
                // Hover names the cell(s) that fire the panel; falls back to the count.
                badgeTitle: coords.length
                    ? `Cell${coords.length > 1 ? 's' : ''} ${coords.join(', ')}`
                    : `${linked.length} linked panel${linked.length !== 1 ? 's' : ''}`,
            };
        },
    }), [coordByPanelId]);
    return (_jsx(EntityArtManager, { levelId: levelId, refreshTrigger: refreshTrigger, title: "UX Panel Images", containerClassName: "events-art-container", listImages: getUxPanelImages, listArchivedImages: getArchivedUxPanelImages, archiveImage: archiveUxPanelImage, restoreImage: restoreUxPanelImage, linkage: linkage }));
};
export default UxPanelsArt;
